import React, { Component, useState, useEffect, useContext } from "react"
import FAQItem from "../faqItem/faqItem"
import Accordion from "react-bootstrap/Accordion"
import AccordionContext from "react-bootstrap/AccordionContext"

export const FAQList = ({ activeCategory }) => {
  const [activeKey, setActiveKey] = useState(null)

  useEffect(() => {
    setActiveKey(null)
  }, [activeCategory])

  return (
    <Accordion>
      <AccordionContext.Provider value={activeKey}>
        {activeCategory.map((question, index) => (
          <FAQItem
            question={question}
            key={question.id}
            activeKey={activeKey}
            index={index}
            handleClick={() => {
              activeKey === question.id
                ? setActiveKey(null)
                : setActiveKey(question.id)
            }}
          />
        ))}
      </AccordionContext.Provider>
    </Accordion>
  )
}
